// 영문 enum → 한글 라벨 매핑

export const CATEGORY_KO: Record<string, string> = {
  repay: '반환', normal: '일반', bad: '악성',
};
// 한글 라벨 + 부연설명 (UI에서 더 명확히 보이도록)
export const CATEGORY_DESC: Record<string, string> = {
  repay: '반환 진행 중 (선지급액에 대한 일차감 회수)',
  normal: '일반 가맹점 (반환금 없음)',
  bad: '악성 (장기 미차감/연락두절)',
};
export const CATEGORY_OPTIONS = [
  { v: 'repay',  k: '반환',  desc: '반환금 있음 — 일차감으로 매입액 회수 중' },
  { v: 'normal', k: '일반',  desc: '반환금 없음 — 단순 정산만' },
  { v: 'bad',    k: '악성',  desc: '연체/연락두절 등 관리 대상' },
];

export const ROLE_KO: Record<string, string> = {
  admin: '관리자', staff: '스태프',
};

// 보안 이벤트 종류 한글 라벨
export const SEC_EVENT_KO: Record<string, string> = {
  login_success:    '로그인 성공',
  login_fail:       '로그인 실패',
  captcha_fail:     '캡차 실패',
  rate_limited:     '로그인 차단(연속실패)',
  password_change:  '비밀번호 변경',
  password_reset:   '비밀번호 초기화',
  user_create:      '계정 생성',
  user_update:      '계정 수정',
  user_delete:      '계정 삭제',
  user_activate:    '계정 활성화',
  user_deactivate:  '계정 비활성화',
  role_change:      '권한 변경',
};
export const SEC_EVENT_OPTIONS = [
  'login_success', 'login_fail', 'captcha_fail', 'rate_limited',
  'password_change', 'password_reset',
  'user_create', 'user_update', 'user_delete',
  'user_activate', 'user_deactivate', 'role_change',
];
export const ROLE_OPTIONS = [
  { v: 'staff', k: '스태프' },
  { v: 'admin', k: '관리자' },
];

// 직급
export const POSITION_OPTIONS = [
  '사원', '주임', '대리', '과장', '차장', '부장', '이사', '상무', '전무', '대표',
];

// User-Agent 원문 → 운영체제/브라우저 요약. 정확한 스펙 대신 실무 판별 위주.
export function parseUserAgent(ua: string | null | undefined): { os: string; browser: string } {
  if (!ua) return { os: '알 수 없음', browser: '알 수 없음' };
  const s = ua;
  let os = '알 수 없음';
  if (/Windows NT/i.test(s)) os = 'Windows';
  else if (/Mac OS X/i.test(s)) os = 'macOS';
  else if (/Android/i.test(s)) os = 'Android';
  else if (/iPhone|iPad|iOS/i.test(s)) os = 'iOS';
  else if (/Linux/i.test(s)) os = 'Linux';
  let browser = '알 수 없음';
  if (/Edg\//i.test(s)) browser = 'Edge';
  else if (/OPR\/|Opera\//i.test(s)) browser = 'Opera';
  else if (/Chrome\/[\d.]+/i.test(s) && !/Edg\//i.test(s)) browser = 'Chrome';
  else if (/Firefox\//i.test(s)) browser = 'Firefox';
  else if (/Safari\//i.test(s) && !/Chrome\//i.test(s)) browser = 'Safari';
  else if (/curl\//i.test(s)) browser = 'curl';
  else if (/Postman/i.test(s)) browser = 'Postman';
  return { os, browser };
}

// 내부 URL/경로 → 사용자 친화 화면명 매핑. 파일별 케이스가 늘면 여기 한 곳에서 추가.
// 앞부분만 매칭 (예: /security/sessions?within=... → '최근 활동 계정')
const SCREEN_MAP: Array<[RegExp, string]> = [
  [/^\/(security\/sessions|security\/sessions.*)$/i, '최근 활동 계정'],
  [/^\/(security\/events|security\/events.*)$/i,   '보안 로그'],
  [/^\/(security\/errors|security\/errors.*)$/i,   '오류 로그'],
  [/^\/security\b/i, '보안'],
  [/^\/users\b/i, '계정 관리'],
  [/^\/change-password\b/i, '비밀번호 변경'],
  [/^\/dashboard\b/i, '대시보드'],
  [/^\/settlements?\/discount\b/i, '할인매매 이체정산'],
  [/^\/settlements?\/realtime\b/i, '실시간 이체정산'],
  [/^\/settlements?\/verify\b/i, '정산 검증'],
  [/^\/settlements?\b/i, '정산'],
  [/^\/notifications-log\b/i, '결제 수신 로그'],
  [/^\/notifications\b/i, '결제 수신내역'],
  [/^\/dormant\b/i, '무매출 알림'],
  [/^\/renewals\b/i, '계약 갱신/종료'],
  [/^\/pending-merchants\b/i, '결제가맹점 추가'],
  [/^\/merchants\/new\b/i, '신규 가맹점 등록'],
  [/^\/merchants\/[^/]+$/i, '가맹점 수정'],
  [/^\/merchants\b/i, '가맹점 관리'],
  [/^\/api\/merchants\b/i, '가맹점 API'],
  [/^\/transactions\b/i, '결제 수신내역 API'],
  [/^\/transfers\b/i, '이체 API'],
  [/^\/auth\/login\b/i, '로그인 API'],
  [/^\/auth\/password\b/i, '비밀번호 변경 API'],
  [/^\/auth\b/i, '인증 API'],
  [/^\/holidays\b/i, '휴일 API'],
  [/^\/merchant-renewals\b/i, '계약 갱신/종료 API'],
  [/^\/dashboard\/summary\b/i, '대시보드 API'],
  [/^\/sale-noti\b/i, 'PG 결제 수신 콜백'],
];
export function pathToScreen(pathOrUrl: string | null | undefined): string | null {
  if (!pathOrUrl) return null;
  let path = pathOrUrl;
  try { path = new URL(pathOrUrl).pathname; } catch { /* 상대 경로면 그대로 */ }
  for (const [re, label] of SCREEN_MAP) if (re.test(path)) return label;
  return null;
}

// SQLite CURRENT_TIMESTAMP 형식(YYYY-MM-DD HH:MM:SS, UTC) 문자열을 KST 표기로 변환.
// 유효하지 않으면 원본을 그대로 반환.
export function utcToKst(s: string | null | undefined): string {
  if (!s) return '-';
  // 이미 T/Z 포함된 ISO 문자열이거나 자체 offset이 있으면 그대로 Date 파싱, 아니면 UTC로 간주.
  const iso = /[TZ]|[+-]\d{2}:\d{2}$/.test(s) ? s : s.replace(' ', 'T') + 'Z';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return s;
  const kst = new Date(d.getTime() + 9 * 3600 * 1000);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${kst.getUTCFullYear()}-${pad(kst.getUTCMonth() + 1)}-${pad(kst.getUTCDate())} ` +
         `${pad(kst.getUTCHours())}:${pad(kst.getUTCMinutes())}:${pad(kst.getUTCSeconds())}`;
}

// 한국식 날짜 표시 헬퍼
const KO_DOW = ['일', '월', '화', '수', '목', '금', '토'];
export function fmtKoDate(s: string): string {
  if (!s || s.length < 10) return s;
  const y = s.slice(0, 4), m = s.slice(5, 7), d = s.slice(8, 10);
  return `${y}년 ${parseInt(m, 10)}월 ${parseInt(d, 10)}일`;
}
export function fmtKoDow(s: string): string {
  if (!s || s.length < 10) return '';
  const dt = new Date(s + 'T00:00:00');
  return KO_DOW[dt.getDay()] + '요일';
}
